// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__33Lpg","headerAmount":"styles_headerAmount__22hc0","row":"styles_row__prRea","amountRow":"styles_amountRow__ybSj7"};